
































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {},
})
export default class TrackingUser extends Vue {
  @Prop() rowSelected!: any

  seletedUser = null

  columns: any = [
    {
      field: 'user_id',
      label: this.$t('label.user_id'),
      width: '80',
    },
    {
      field: 'name',
      label: this.$t('label.username'),
    },
    {
      field: 'san_id',
      label: this.$t('label.san_id'),
    },
  ]
}
